import {
  IconAbacus,
  IconActivityHeartbeat,
  IconArrowUp,
  IconBell,
  IconBriefcase,
  IconCalendarEvent,
  IconChartBarPopular,
  IconChartCovariate,
  IconDatabase,
  IconDirections,
  IconFileAnalytics,
  IconFolder,
  IconPlugConnected,
  IconReceipt2,
  IconReport,
  IconSettings,
  IconTable,
  IconZoomMoney,
} from "@tabler/icons-react"
import { ComponentType } from "react"

import { Permissions } from "@costory/front/utils/permissions"

export type SidebarItem = {
  path?: string
  name: string
  icon: ComponentType
  position?: "top" | "bottom"
  links?: SidebarItem[]
  role?: string
  tooltip?: string
  isFeatureFlagged?: boolean
  onboarding?: boolean
}

export const SIDEBAR_ITEMS: SidebarItem[] = [
  {
    path: "reports",
    name: "Library",
    icon: IconFolder,
    position: "top",
    role: Permissions.Member,
  },
  {
    path: "explorer",
    name: "Explorer",
    icon: IconChartBarPopular,
    position: "top",
    role: Permissions.Member,
    tooltip: "Explore multi-cloud spend, correlate it to your business growth",
  },
  {
    name: "Monitor",
    icon: IconDirections,
    role: Permissions.Member,
    position: "top",
    links: [
      {
        path: "digests",
        name: "Digest",
        icon: IconAbacus,
        tooltip: "Report your findings",
      },
      {
        path: "alerts",
        name: "Alerts",
        icon: IconBell,
        position: "top",
        tooltip: "Get notified of cost anomalies.",
        role: Permissions.Member,
      },
      {
        path: "budgets",
        name: "Budgets",
        icon: IconTable,
        position: "top",
        role: Permissions.Member,
        tooltip: "Plan and manage your cloud spending.",
      },
      {
        path: "scheduled-reports",
        name: "Scheduled Reports",
        icon: IconReport,
        tooltip: "Configure automated digest reports",
      },
    ],
  },
  {
    name: "Enrich",
    icon: IconChartCovariate,
    links: [
      {
        path: "labels-explorer",
        name: "Labels Explorer",
        icon: IconFileAnalytics,
        position: "top",
        role: Permissions.Member,
        tooltip: "Explore the labels available in your stack",
      },
      {
        path: "virtual-dimensions",
        name: "Virtual Dimensions",
        icon: IconBriefcase,
        position: "top",
        role: Permissions.Member,
        tooltip: "Your FinOps Rosetta Stone",
      },
      {
        path: "formulas",
        name: "Formulas",
        icon: IconZoomMoney,
        position: "top",
        role: Permissions.Member,
        tooltip: "Normalize your costs",
      },
      {
        path: "explorer",
        name: "Events",
        icon: IconCalendarEvent,
        position: "top",
        tooltip: "Contextualize your cost analysis",
        role: Permissions.Member,
      },
    ],
  },
  {
    name: "Settings",
    icon: IconSettings,
    role: Permissions.Member,
    onboarding: true,
    position: "top",
    links: [
      {
        path: "onboarding",
        name: "Onboarding",
        icon: IconArrowUp,
        position: "top",
        role: Permissions.Member,
        onboarding: true,
        tooltip: "Onboarding steps",
      },
      {
        path: "integration",
        name: "Integrations",
        icon: IconPlugConnected,
        position: "top",
        role: Permissions.Member,
        onboarding: true,
        tooltip: "Connect Integrations",
      },
      {
        name: "Data Sources",
        icon: IconDatabase,
        role: Permissions.Member,
        onboarding: true,
        position: "top",
        links: [
          {
            path: "datasources/billing",
            name: "Billing",
            icon: IconReceipt2,
            position: "top",
            role: Permissions.Member,
            onboarding: true,
            tooltip: "Connect data sources: Billing",
          },
          {
            path: "datasources/metrics",
            name: "Metrics",
            icon: IconZoomMoney,
            position: "top",
            role: Permissions.Member,
            tooltip: "Connect data sources: Metrics",
          },
          {
            name: "Datasources",
            icon: IconDatabase,
            role: Permissions.Member,
            position: "top",
            path: "datasources",
            isFeatureFlagged: true,
          },
        ],
      },
      {
        path: "data-health",
        name: "Data Health",
        icon: IconActivityHeartbeat,
        position: "top",
        role: Permissions.Member,
        tooltip: "Monitor data freshness",
      },
    ],
  },
]
